import React, { useEffect, useState } from "react";
import ModalComponent from "../../components/Modals/modal";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import SearchComponent from "../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { assignStoreManager, getAnOrder, getOrderTimeline, getStockValues } from "../../redux/Orders/ordersAction";
import { useParams } from "react-router-dom";


const AssignStoreManager = ({ orderId, deliveryDetails, variantId }) => {
  const [show, setShow] = useState(false);
    const { id, type } = useParams();
  const dispatch = useDispatch();
  const { storeManagers } = useSelector((state) => state.orders);
  const [loading, setLoading] = useState(false);
  const [isToggleSelect, setToggleSelect] = useState(false);
  const [selectedStoreManager, setSelectedStoreManager] = useState(null);

  const [searchValue, setSearchValue] = useState("");
  

  const filteredStoreManagers = storeManagers.filter((manager) =>
    manager.location.name.toLowerCase().includes(searchValue.toLowerCase()) ||
    manager.location.store_manager_name.toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleAssign = () => {
    setLoading(true)
    dispatch(assignStoreManager({
      order_id: orderId,
      manager_id: selectedStoreManager.location.store_manager
    })).then((res)=>{
      if(res?.type === "assignStoreManager/fulfilled"){
        setLoading(false)
        setShow(false)
        dispatch(
            getAnOrder({
              orderType: type,
              id: id,
            })
        );
        dispatch(getOrderTimeline({ id }));
      }
      else if(res?.type === "assignStoreManager/rejected"){
        setLoading(false)
      }
    }).catch(()=>{
      setLoading(false)
    })
  };
  console.log(id, type)

  useEffect(()=>{
    dispatch(getStockValues({
      variant_id: variantId
    }));
  },[dispatch, variantId])

  return (
    <div>
      <button
        onClick={() => setShow(true)}
        className="disabled:bg-[#ABB6AC] text-white text-sm h-[36px]  px-5 bg-[#2B8C34] hover:bg-opacity-[0.9] rounded-[8px] font-medium transition-all"
      >
        Assign Store Manager
      </button>

      <ModalComponent
        show={show}
        showModal={() => setShow(false)}
        title="Assign Store Manager"
        subtitle=""
      >
        <div className="mt-3">
          <h6 className="text-[#5F6D60] font-medium text-sm">
            Select a store manager to handle this order based on the delivery
            location
          </h6>

          <div className="bg-[#F7F7F5] border border-[#EDECE7] py-1 px-2 rounded-lg mt-4">
            {/* ADDRESS */}
            <div className="flex gap-2 border-b py-2 border-b-[#E1E6E1] items-center">
              <p className="text-[#79887B] font-semibold text-xs ">Address:</p>
              <div className="bg-white border border-[#E1E6E1] px-1 py-[2px] rounded-[4px] ">
                <p className="text-[#5F6D60] font-semibold text-xs ">
                  {deliveryDetails?.address || "N/A"}
                </p>
              </div>
            </div>

            {/* STATE */}
            <div className="flex gap-2 border-b py-2 border-b-[#E1E6E1] items-center">
              <p className="text-[#79887B] font-semibold text-xs ">State:</p>
              <div className="bg-white border border-[#E1E6E1] px-1 py-[2px] rounded-[4px] ">
                <p className="text-[#5F6D60] font-semibold text-xs ">
                  {deliveryDetails?.state || "N/A"}
                </p>
              </div>
            </div>

            {/* LGA */}
            <div className="flex gap-2 py-2 items-center">
              <p className="text-[#79887B] font-semibold text-xs ">LGA:</p>
              <div className="bg-white border border-[#E1E6E1] px-1 py-[2px] rounded-[4px] ">
                <p className="text-[#5F6D60] font-semibold text-xs ">
                  {deliveryDetails?.lga || "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <div className="relative">
              <p className="font-medium text-sm leading-[18px] text-[#344335]">
                Store Manager
              </p>
              <div
                className="flex items-center cursor-pointer justify-between outline-0 h-[44px] bg-white rounded-[8px] border border-[#E1E6E1] mt-[4px]  px-[14px] w-full font-semibold text-sm leading-5 text-[#96A397]"
                onClick={() => setToggleSelect(!isToggleSelect)}
              >
                
               {
                selectedStoreManager?.location.id ? (
                  <span className="flex gap-1">
                    <span className="font-semibold text-sm text-[#344335]">
                      {selectedStoreManager.location.name},
                    </span>
                    <span className="text-sm text-[#5F6D60] font-semibold">
                      {selectedStoreManager?.location?.phone || selectedStoreManager?.location?.store_manager_name || "N/A"}
                    </span>
                  </span>
                ) : (
                  <span>Select store manager</span>
                )
}

                {isToggleSelect ? (
                  <ExpandLess
                    className="text-[#ABB6AC] cursor-pointer"
                    style={{ fontSize: "18px" }}
                  />
                ) : (
                  <ExpandMore
                    className="text-[#ABB6AC] cursor-pointer"
                    style={{ fontSize: "18px" }}
                  />
                )}
              </div>

              {isToggleSelect && (
                <div
                  className="absolute rounded-[8px] p-[8px] w-full bg-white z-20 max-h-[250px] overflow-y-scroll "
                  style={{
                    boxShadow:
                      "0px 0px 1px rgba(0, 0, 0, 0.25), 0px 16px 32px rgba(0, 0, 0, 0.08",
                  }}
                >
                  <div className="mb-2">
                    <SearchComponent
                      placeholder="Search..."
                      searchValue={searchValue}
                     handleChange={(e) => setSearchValue(e.target.value)}
                    />
                  </div>

                  {
                  filteredStoreManagers.length === 0 ? (
                    <div className="flex justify-center items-center h-[100px]">
                      <p className="text-[#96A397] text-sm">No store manager found</p>
                    </div>
                  ) : ( 
                  filteredStoreManagers.map((manager, index) => {
                    return (
                      <div
                        onClick={() => {
                          setSelectedStoreManager(manager);
                          setToggleSelect(false);
                        }}
                        key={index}
                        className={`flex items-center gap-3 px-[16px] py-[12px] hover:bg-[#F6F7F6] hover:rounded cursor-pointer ${
                          selectedStoreManager?.location.id === manager.location.id ? "bg-[#EDF7EE] rounded" : ""
                        }`}
                      >
                         <div className="flex-1">
                          <div className="font-semibold text-sm text-[#3E473F]">{manager.location.name}</div>
                          <div className="text-[#3E473F] text-xs font-medium">
                            {manager.location.store_manager_name}, <span className="text-[#5F6D60]">{manager?.location?.phone || "N/A"}</span>
                          </div>
                        </div>
                        <div>
                          <span className="bg-[#FFFFFF] border border-[#E1E6E1] rounded px-3 py-1 text-[#5F6D60] text-sm font-semibold">
                            {manager.total_quantity} Units Available
                          </span>
                        </div>
                      </div>
                    );
                  })
                  )
                  }
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-end mt-8 mb-3">
          <button
            onClick={() => setShow(false)}
            type="submit"
            disabled={false}
            className="rounded-lg px-6 py-3 text-[#5C715E] text-sm font-medium transition-all"
          >
            Cancel
          </button>
          <div className="flex gap-2">
            <button
              type="submit"
             disabled={!selectedStoreManager || loading}
             onClick={handleAssign}
              className="bg-primary 
                                 disabled:bg-[#ABB6AC] 
                                 rounded-lg px-6 py-3 text-white disabled:cursor-not-allowed text-sm font-medium hover:bg-[#24752B] transition-all"
            >
              {loading ? "Assigning..." : "Assign Store Manager"}
            </button>
          </div>
        </div>
      </ModalComponent>
    </div>
  );
};

export default AssignStoreManager;
